import * as noticeAPI from '@/api/notice'

const state = {
  company: 'FashionShop',
  shop_name: 'FashionShop',
  phone: '',
  email: '',
  address: ''
}

const getters = {
  getShopInfo: state => state
}

const mutations = {
  SET_SHOP_INFO(state, info) {
    state.company = info.company || state.company
    state.shop_name = info.shop_name || state.shop_name
    state.phone = info.phone || state.phone
    state.email = info.email || state.email
    state.address = info.address || state.address
  }
}

const actions = {
  fetchShopInfo({ commit }) {
    return noticeAPI.getShopInfo().then(res => {
      if (res.status === 200 && res.data) {
        commit('SET_SHOP_INFO', res.data)
      }
    }).catch(() => {})
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
